import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

export const RecommendedFlag = () => {
	return (
		<>
			<div
				className={cn(
					'flex w-full flex-col items-center justify-center bg-roomSelection-recommended md:bg-roomSelection-recommendedDesktop'
				)}
				style={{ writingMode: 'vertical-rl' }}
			>
				<Typography
					element="p"
					style="p-s-bold"
					className={cn(
						'rotate-180 pb-12 pt-6 text-roomSelection-recommendedTextDesktop md:text-roomSelection-recommendedTextDesktop'
					)}
				>
					{translate('room-selection-recommended')}
				</Typography>
			</div>
			<div className={cn('h-12 w-24 bg-transparent')}>
				<div
					className={cn(
						'h-0 w-0 border-b-[12px] border-l-[12px] border-r-[12px] border-b-transparent border-l-roomSelection-recommended border-r-roomSelection-recommended md:border-l-roomSelection-recommendedDesktop md:border-r-roomSelection-recommendedDesktop'
					)}
				></div>
			</div>
		</>
	)
}
